<template>
  <div v-if="editor" class="editor">
    <div class="my-1 ml-2">
      <b-button
        variant="outline-secondary"
        class="editor-btn"
        :disabled="!isEditable"
        :class="{ 'is-active': editor.isActive('bold') }"
        @click="editor.chain().focus().toggleBold().run()"
      >
        <font-awesome-icon icon="bold" />
      </b-button>
      <b-button
        variant="outline-secondary"
        class="editor-btn ml-1"
        :disabled="!isEditable"
        :class="{ 'is-active': editor.isActive('italic') }"
        @click="editor.chain().focus().toggleItalic().run()"
      >
        <font-awesome-icon icon="italic" />
      </b-button>
      <b-button
        variant="outline-secondary"
        class="editor-btn ml-1"
        :disabled="!isEditable"
        :class="{ 'is-active': editor.isActive('bulletList') }"
        @click="editor.chain().focus().toggleBulletList().run()"
      >
        <font-awesome-icon icon="list-ul" />
      </b-button>
      <b-button
        variant="outline-secondary"
        class="editor-btn ml-1"
        :disabled="!isEditable"
        :class="{ 'is-active': editor.isActive('underline') }"
        @click="editor.chain().focus().toggleUnderline().run()"
      >
        <font-awesome-icon icon="underline" />
      </b-button>
    </div>
    <editor-content class="editor-body" :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent, Extension } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import Underline from "@tiptap/extension-underline";

export default {
  components: {
    EditorContent,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    limitedCharactersPerRow: {
      type: Number,
      default: 0,
    },
    limitedRows: {
      type: Number,
      default: 0,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  watch: {
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value;
      if (isSame) {
        return;
      }
      this.editor.commands.setContent(value, false);
    },
    isEditable(value) {
      this.editor.setOptions({ editable: value });
    },
  },
  mounted() {
    this.editor = new Editor({
      editable: this.isEditable,
      extensions: [
        StarterKit,
        Placeholder.configure({
          placeholder: this.placeholder,
        }),
        Underline,
      ],
      content: this.value,
      onUpdate: () => {
        const message = { rowLengthExceded: false, rowCharactersLengthExceded: false };
        // Count children nodes (rows)
        if (this.limitedRows > 0 && this.editor.view.state.doc.childCount > this.limitedRows) {
          message.rowLengthExceded = true;
        }
        // Iterate children nodes and count characters for every node
        this.editor.view.state.doc.forEach(node => {
          if (
            this.limitedCharactersPerRow > 0 &&
            node.textContent.length > this.limitedCharactersPerRow
          ) {
            message.rowCharactersLengthExceded = true;
          }
        });
        this.$emit("update", message);
      },
      onBlur: () => {
        this.$emit("updateOnFocusOut", this.editor.getHTML());
      },
    });
  },
  beforeUnmount() {
    this.editor.destroy();
  },
};
</script>
